import { render, staticRenderFns } from "./AudioTranscript.vue?vue&type=template&id=06cfe29e"
import script from "./AudioTranscript.vue?vue&type=script&lang=js"
export * from "./AudioTranscript.vue?vue&type=script&lang=js"
import style0 from "./AudioTranscript.vue?vue&type=style&index=0&id=06cfe29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports